// -----------------------------------------------
// Password validation object based on below rules
// -----------------------------------------------
// The password shall contain a minimum of twelve (12)
// and maximum of sixteen (16) characters comprising
// at least two (2) of the following:
// 1. Uppercase (A through Z)
// 2. Lowercase (a through z)
// 3. Digits (0-9)
// 4. Special Characters (!, $, #, %, etc.)

const validator = {
  getMessage(field) {
    return field + " is not a valid";
  },
  validate(str) {
    return /(?=.*[_!@#$%^&*-])(?=.*\d)(?!.*[.\n])(?=.*[a-z])(?=.*[A-Z])^.{12,16}$/.test(
      str
    );
  }
};

export default validator;
